<template>
	<div style="display: inline-block;">
		<Button class="jxyd-borderbtn jxyd-searchbtn" title="添加商品" @click="openSelectCommodityModal"
			style="margin-right:10px;">
			<Icon type="md-add-circle" size='18' /> 添加
		</Button>
		<Modal v-model="selectCommodityModal" draggable sticky scrollable :fullscreen="fullscreen" :width="1300"
			:styles="{top: '20px','backgroud-color':'white'}">
			<p slot="header" class="modal-header">
				<img src="/static/imgs/shangpin.png" class="jxyd-imgicon" />
				<span style="float: left;font-weight: bold;">选取商品</span>
			</p>
			<div class="modal-content">
				<div style="padding: 16px;">
					<div id="box-search">
						<div class="box-search-left">
							<Input type="text" class="search_input" v-model="searchItems.name" placeholder="请输入商品名/条码"
								@keyup.enter.native="initCommodityList(1)" />
							<button class="jxyd-button jxyd-primary jxyd-searchbtn"
								@click="initCommodityList(1)">查询</button>
							<label class="jxyd-a" @click="advancedQuery = true">&nbsp;高级查询</label>
						</div>
						<Button class="jxyd-borderbtn box-search-right" @click="addCommodity" v-show="permission.isAdd">
							新建商品
						</Button>
					</div>
					<Table stripe :height='500' :columns="commodityColumn" :data="commodityData">
					</Table>
					<div id="page-box">
						<Page show-sizer :total="commodityCount" :page-size="searchItems.pageSize"
							@on-change="pageChange" show-total show-elevator :page-size-opts='pageSizeOpts'
							:current="searchItems.pageIndex" @on-page-size-change='pageSizeChange'>
						</Page>
					</div>
				</div>

				<!-- 使用封装的自定义抽屉组件 -->
				<CustomDrawer v-model="shoppingCart" :title="`已选商品`" :width="700" placement="right" :mask="true"
					:mask-closable="true" :closable="true" @close="handleDrawerClose">
					<template #title>
						<div class="drawer-title">
							<div class="drawer-title-left">
								已选
								<span class="drawer-title-left-number">
									{{selectedCommodityCount}}
								</span>
							</div>
							<div class="drawer-title-right" @click="cleanSelected">清空已选</div>
						</div>
					</template>

					<div>
						<Table :height='680' disabled-hover :columns="selectedColumn" :data="selectedData">
						</Table>
					</div>
				</CustomDrawer>

				<!-- 使用封装的自定义抽屉组件 -->
				<CustomDrawer v-model="advancedQuery" :title="`高级查询`" :width="300" placement="right" :mask="true"
					:mask-closable="true" :closable="true">
					<template #title>
						<div class="drawer-title">
							<div class="drawer-title-left">
								<Icon type="ios-search" :size='18' />
								高级查询
							</div>
							<div class="drawer-title-right"></div>
						</div>
					</template>
					<div class="drawer-content">
						<div class="drawer-content-item content-left-right-split">
							<label>商品种类&nbsp;</label>
							<selectTree v-model="searchItemsType" :treeData="commodityTypeData" :border='false'
								style="flex: 1;">
							</selectTree>
						</div>
						<div class="drawer-content-item content-left-right-split">
							<label>所属仓库&nbsp;</label>
							<Select size="small" style="flex: 1;" placeholder="请选择" filterable clearable
								v-model="searchItems.depotId" @keyup.enter.native="initListData(1)">
								<Option :value="0" :key="0">请选择</Option>
								<Option v-for="item in depotList" :value="item.id" :key="item.id">
									{{ item.depotName }}
								</Option>
							</Select>
						</div>
						<div class="drawer-content-item content-left-right-split">
							<label>商品状态&nbsp;</label>
							<Select v-model="searchItems.isUse" size="small" style="flex: 1;" clearable
								placeholder="请选择">
								<Option :value="-1" key="请选择">
									请选择
								</Option>
								<Option :value="1" key="已启用">
									已启用
								</Option>
								<Option :value="0" key="已停用">
									已停用
								</Option>
							</Select>
						</div>
						<div class="drawer-content-item content-left-right-split">
							<label>商品规格&nbsp;</label>
							<input type="text" placeholder="请输入" class="content-input" v-model="searchItems.format" />
						</div>
						<div class="drawer-content-item content-left-right-split">
							<label>备注&nbsp;</label>
							<input type="text" placeholder="请输入" v-model="searchItems.note" class="content-input" />
						</div>
					</div>
					<template #footer>
						<button class="jxyd-button" @click="advancedQuery = false"
							style="margin-right: 10px;">取消</button>
						<button class="jxyd-button jxyd-primary" type="primary"
							@click="initCommodityList(1)">确定</button>
					</template>
				</CustomDrawer>

				<!-- 使用封装的自定义抽屉组件 -->
				<CustomDrawer v-model="selectedSKU" :title="`选择单品`" :width="700" placement="right" :mask="true"
					:mask-closable="true" :closable="true">
					<template #title>
						<div class="drawer-title">
							<div class="drawer-title-left">
								<Icon type="ios-search" :size='18' />
								选择单品
							</div>
							<div class="drawer-title-right"></div>
						</div>
					</template>
					<div class="drawer-content">
						<Table :height='610' disabled-hover :columns="skuColumn" :data="currentCommodity.data">
						</Table>
					</div>
					<template #footer>
						<div class="selected-sku">
							<Icon type="md-cart" size='20' />
							<Badge :count="getCurrentCommodityQuantity">
								<span>合计:&nbsp;¥{{getCurrentCommodityAmount}}</span>
							</Badge>
						</div>
						<button class="jxyd-button" @click="selectedSKU = false" style="margin-right: 10px;">取消</button>
						<button class="jxyd-button jxyd-primary" type="primary" @click="saveSelectedSKU">确定</button>
					</template>
				</CustomDrawer>
			</div>
			<div slot="footer">
				<div class="selected-goods" @click="toggleShoppingCart">
					<Icon type="md-cart" size='20' />
					<Badge :count="selectedCommodityCount">
						<span>合计:&nbsp;¥{{selectedCommodityAmount}}</span>
					</Badge>
				</div>
				<div class="footer-tool">
					<button class="jxyd-button" @click="selectCommodityModal = false">取消</button>
					<button class="jxyd-button jxyd-primary" type="primary" @click="Submit">确定</button>
				</div>
			</div>
		</Modal>
		<!-- 使用封装的图片预览子组件 -->
		<ImagePreview ref="imagePreview" :images="previewImagesList" :visible.sync="previewVisible"
			:initial-index="currentImageIndex" @change="onPreviewImageChange" />
	</div>
</template>

<script>
	import request from '@/utils/request'
	import selectTree from '@/components/selectTree'
	import ImagePreview from '@/components/ImagePreview' // 导入图片预览子组件
	import CustomDrawer from '@/components/CustomDrawer' // 导入自定义抽屉组件
	import formatNum from '@/utils/formatNum'

	export default {
		name: 'selectCommodityModal',
		props: ['selectedCommodity', 'type'],
		components: {
			ImagePreview,
			CustomDrawer,
			selectTree
		},
		computed: {
			searchItemsType: {
				get() {
					this.$nextTick(() => {
						if (this.searchItems.type.length > 0) {
							return this.searchItems.type[0];
						}
						return [];
					})
				},
				set(newVal) {
					if (newVal) {
						this.searchItems.type = [newVal];
					} else {
						this.searchItems.type = [];
					}
				}
			},
			isMultipleLines() {
				const seen = new Set();
				let units = [];
				if (this.currentCommodity && this.currentCommodity.commodity.id) {
					let array = this.commoditySelected.filter(m => m.commodity.id == this.currentCommodity.commodity.id);
					return array.some(item => {
						if (seen.has(item.commodity.id)) {
							return true;
						}
						for (let i = 0; i < item.data.length; i++) {
							if (units.length > 0 && units.indexOf(item.data[i].unit) <= -1) {
								return true;
							}
							units.push(item.data[i].unit);
						}
						seen.add(item.commodity.id);
						this.isAddAnotherLine = false;
						return false;
					});
				} else {
					this.isAddAnotherLine = false;
					return false;
				}
			},
			getCurrentCommodityStock() {
				let quantity = 0;
				try {
					for (let n = 0; n < this.currentCommodity.commodity.commodityPriceTypeGroups.length; n++) {
						quantity += this.currentCommodity.commodity.commodityPriceTypeGroups[n].commodityPriceTypes.length;
					}
				} catch (e) {

				}
				return quantity;
			},
			selectedData() {
				let array = [];
				this.commoditySelected.forEach((item, index) => {
					item.data.forEach((item2, index2) => {
						array.push({
							index: index,
							index2: index2,
							priceType: item2.priceType,
							quantity: item2.quantity,
							imgFiles: item2.imgFiles,
							sellByDate: item2.sellByDate,
							unit: item2.unit,
							intoPrice: item2.intoPrice,
							retailPrice: item2.retailPrice,
							wholesalePricePrice: item2.wholesalePricePrice
						})
					})
				})
				return array;
			},
			getCurrentCommodityAmount() {
				let sumAmount = 0;
				if (this.currentCommodity) {
					this.currentCommodity.data.forEach(item => {
						let unitData = this.getUnitData(item.unit);
						let price = 0;
						if (this.type == '0' || this.type == '1') {
							price = item.intoPrice / unitData.conversionRate;
						}
						if (this.type == '2' || this.type == '3') {
							price = item.retailPrice / unitData.conversionRate;
						}
						sumAmount += item.quantity * price;
					});
				}
				return formatNum(sumAmount)
			},
			getCurrentCommodityQuantity() {
				let sumQuantity = 0;
				if (this.currentCommodity) {
					this.currentCommodity.data.forEach(item => {
						sumQuantity += item.quantity;
					});
				}
				return formatNum(sumQuantity)
			},
		},
		data() {
			return {
				selectCommodityModal: false,
				fullscreen: false,
				commodityTypeData: [],
				commodityColumn: [{
						title: '商品图片',
						key: 'imgs',
						width: 100,
						render: (h, params) => {
							return [h('div', {
								style: {
									'width': '40px',
									'height': '40px',
									'cursor': 'pointer'
								},
								on: {
									click: (val) => {
										this.previewSkuImages(params.row.imgFile);
									}
								}
							}, [h('Avatar', {
								style: {
									'width': '100%',
									'height': '100%',
								},
								attrs: {
									'src': params.row.imgFile.length > 0 ? params.row.imgFile[
											0]
										.url :
										'/file/file/GetFile?fileName=DefaultCommodity.png&path=/app/Uploads/FIXIMG/DefaultCommodity.png',
								}
							})])];
						}
					},
					{
						title: '商品',
						key: 'name',
						width: 150,
						fixed: 'left',
						render: (h, params) => {
							return h('a', {
								class: 'jxyd-a',
								on: {
									click: (e) => {
										this.selectCommodityModal = false;
										this.$router.push({
											path: 'commoditydetailinfo',
											query: {
												commodityId: params.row.id
											}
										});
									}
								}
							}, params.row.name);
						}
					},
					{
						title: '数量',
						key: 'quantity',
						align: 'left',
						width: 120,
						render: (h, params) => {
							return h('InputNumber', {
								attrs: {
									'value': this.getCommodityQuantity(params.row),
									'min': 0,
									'max': this.type == '1' || this.type == '2' ? params.row.stock :
										99999999999,
									'placeholder': "请输入数量",
									'disabled': !(this.isDisableStock(params.row.stock) && params.row
										.isUse)
								},
								style: {
									'width': '100%'
								},
								on: {
									'on-change': (val2) => {
										// 使用防抖函数
										this.commodityQuantityChangeDebounced(val2, params.row);
									},
									'on-focus': (val) => {
										if (!this.isCase1(params.row)) {
											// 使用防抖函数
											this.debounceAddCommodityCase2(params.row);
										}
									}
								}
							});
						}
					},
					{
						title: '单位',
						key: 'unit',
						width: 120
					},
					{
						title: '当前库存',
						key: 'stock',
						width: 120
					},
					{
						title: '种类',
						key: 'type',
						width: 170
					},
					{
						title: '采购价',
						key: 'intoPrice',
						width: 120,
						render: (h, params) => {
							return h('span', {}, params.row.intoPrice + '元');
						}
					},
					{
						title: '零售价',
						key: 'retailPrice',
						width: 120,
						render: (h, params) => {
							return h('span', {}, params.row.retailPrice + '元');
						}
					},
					{
						title: '批发价',
						key: 'wholesalePricePrice',
						width: 120,
						render: (h, params) => {
							return h('span', {}, params.row.wholesalePricePrice + '元');
						}
					},
					{
						title: '备注',
						key: 'note',
						width: 300,
					}
				],
				skuColumn: [{
						title: '商品图片',
						key: 'imgFiles',
						width: 100,
						render: (h, params) => {
							return [h('div', {
								style: {
									'width': '40px',
									'height': '40px',
									'cursor': 'pointer'
								},
								on: {
									click: (val) => {
										this.previewSkuImages(params.row.imgFiles);
									}
								}
							}, [h('Avatar', {
								style: {
									'width': '100%',
									'height': '100%',
								},
								attrs: {
									'src': params.row.imgFiles.length > 0 ? params.row
										.imgFiles[
											0]
										.url :
										'/file/file/GetFile?fileName=DefaultCommodity.png&path=/app/Uploads/FIXIMG/DefaultCommodity.png',
								}
							})])];
						}
					},
					{
						title: '商品',
						key: 'name',
						width: 150,
						render: (h, params) => {
							return h('a', {
								class: 'jxyd-a',
								on: {
									click: (e) => {
										this.selectCommodityModal = false;
										this.$router.push({
											path: 'commoditydetailinfo',
											query: {
												commodityId: this.currentCommodity.commodity.id
											}
										});
									}
								}
							}, this.currentCommodity.commodity.name);
						}
					},
					{
						title: '规格',
						key: 'priceType',
						width: 180,
						fixed: 'left'
					},
					{
						title: '数量',
						key: 'quantity',
						align: 'left',
						width: 120,
						render: (h, params) => {
							return h('InputNumber', {
								attrs: {
									'min': 0,
									'value': params.row.quantity,
									'max': this.type == '1' || this.type == '2' ? this
										.getCurrentCommodityTypeMaxStock(params.row) : 99999999999,
									'placeholder': "请输入数量"
								},
								style: {
									'width': '100%'
								},
								on: {
									'input': (val2) => {
										this.currentCommodity.data[params.index].quantity = val2;
									}
								}
							});
						}
					},
					{
						title: '单位',
						key: 'unit',
						width: 100,
						render: (h, params) => {
							return [h('Select', {
									props: {
										transfer: true,
										value: params.row.unit
									},
									on: {
										input: (val) => {
											this.skuUnitChange(params.index, val);
										}
									},
								},
								this.currentCommodity.commodity.extraUnits.map(function(type) {
									return h('Option', {
										props: {
											value: type.unit,
											key: type.unit
										}
									}, type.unit);
								})
							)];
						}
					},
					{
						title: '当前库存',
						key: 'stock',
						width: 120,
						render: (h, params) => {
							return h('label', {}, this.getCurrentCommodityTypeMaxStock(params.row));
						}
					},
					{
						title: '采购价',
						key: 'intoPrice',
						width: 120,
						render: (h, params) => {
							let price = 0;
							let unitData = this.getUnitData(params.row.unit);
							if (unitData) {
								price = formatNum(params.row.intoPrice / unitData
									.conversionRate);
							}
							return h('span', {}, price + '元');
						}
					},
					{
						title: '零售价',
						key: 'retailPrice',
						width: 120,
						render: (h, params) => {
							let price = 0;
							let unitData = this.getUnitData(params.row.unit);
							if (unitData) {
								price = formatNum(params.row.retailPrice / unitData
									.conversionRate);
							}
							return h('span', {}, price + '元');
						}
					},
					{
						title: '批发价',
						key: 'wholesalePricePrice',
						width: 120,
						render: (h, params) => {
							let price = 0;
							let unitData = this.getUnitData(params.row.unit);
							if (unitData) {
								price = formatNum(params.row.wholesalePricePrice / unitData.conversionRate);
							}
							return h('span', {}, price + '元');
						}
					}
				],
				commodityData: [],
				commodityCount: 0,
				searchItems: {
					name: '',
					code: '',
					format: '',
					isUse: -1,
					depotId: 0,
					note: '',
					type: [],
					sort: '',
					pageSize: 10,
					pageIndex: 1
				},
				advancedSelect: false,
				shoppingCart: false,
				selectedColumn: [{
						title: '商品图片',
						key: 'imgFiles',
						width: 100,
						render: (h, params) => {
							return [h('div', {
								style: {
									'width': '40px',
									'height': '40px',
									'cursor': 'pointer'
								},
								on: {
									click: (val) => {
										this.previewSkuImages(params.row.imgFiles);
									}
								}
							}, [h('Avatar', {
								style: {
									'width': '100%',
									'height': '100%',
								},
								attrs: {
									'src': params.row.imgFiles.length > 0 ? params.row
										.imgFiles[
											0]
										.url :
										'/file/file/GetFile?fileName=DefaultCommodity.png&path=/app/Uploads/FIXIMG/DefaultCommodity.png',
								}
							})])];
						}
					},
					{
						title: '商品',
						key: 'name',
						width: 150,
						render: (h, params) => {
							return h('a', {
								class: 'jxyd-a',
								on: {
									click: (e) => {
										this.selectCommodityModal = false;
										this.$router.push({
											path: 'commoditydetailinfo',
											query: {
												commodityId: this.commoditySelected[params.row
													.index].commodity.id
											}
										});
									}
								}
							}, this.commoditySelected[params.row.index].commodity.name);
						}
					},
					{
						title: '规格',
						key: 'priceType',
						width: 180,
						fixed: 'left'
					},
					{
						title: '数量',
						key: 'quantity',
						align: 'left',
						width: 120,
						render: (h, params) => {
							return h('InputNumber', {
								attrs: {
									'min': 0,
									'value': params.row.quantity,
									'max': this.type == '1' || this.type == '2' ? this
										.getSelectedCommodityTypeMaxStock(params.row.index, params.row
											.index2) : 99999999999,
									'placeholder': "请输入数量"
								},
								style: {
									'width': '100%'
								},
								on: {
									'input': (val2) => {
										this.commoditySelected[params.row.index].data[params.row
											.index2].quantity = val2;
									}
								}
							});
						}
					},
					{
						title: '单位',
						key: 'unit',
						width: 100,
						render: (h, params) => {
							return [h('Select', {
									props: {
										transfer: true,
										value: params.row.unit
									},
									on: {
										input: (val) => {
											this.selectedUnitChange(params.row.index, params.row
												.index2, val);
										}
									},
								},
								this.commoditySelected[params.row.index].commodity.extraUnits.map(function(
									type) {
									return h('Option', {
										props: {
											value: type.unit,
											key: type.unit
										}
									}, type.unit);
								})
							)];
						}
					},
					{
						title: '当前库存',
						key: 'stock',
						width: 120,
						render: (h, params) => {
							return h('label', {}, this.getCommodityTypeStockByParam(
								params.row.index, params.row.index2));
						}
					},
					{
						title: '采购价',
						key: 'intoPrice',
						width: 120,
						render: (h, params) => {
							let price = 0;
							let unitData = this.getUnitData(params.row.unit);
							if (unitData) {
								price = formatNum(params.row.intoPrice / unitData.conversionRate);
							}
							return h('span', {}, price + '元');
						}
					},
					{
						title: '零售价',
						key: 'retailPrice',
						width: 120,
						render: (h, params) => {
							let price = 0;
							let unitData = this.getUnitData(params.row.unit);
							if (unitData) {
								price = formatNum(params.row.retailPrice / unitData.conversionRate);
							}
							return h('span', {}, price + '元');
						}
					},
					{
						title: '批发价',
						key: 'wholesalePricePrice',
						width: 120,
						render: (h, params) => {
							let price = 0;
							let unitData = this.getUnitData(params.row.unit);
							if (unitData) {
								price = formatNum(params.row.wholesalePricePrice / unitData.conversionRate);
							}
							return h('span', {}, price + '元');
						}
					},
					{
						title: '操作',
						key: 'action',
						align: 'center',
						fixed: 'right',
						width: 120,
						render: (h, params) => {
							let btnArray = [];
							btnArray.push(h('a', {
								class: 'jxyd-a',
								props: {},
								style: {
									'margin-right': '10px'
								},
								on: {
									click: (val) => {
										this.removeSelectedItem(params.row.index, params.row
											.index2);
									}
								}
							}, "删除"));
							btnArray.push(h('a', {
								class: 'jxyd-a',
								props: {},
								style: {},
								on: {
									click: (val) => {
										this.copyItem(params.row.index, params.row.index2);
									}
								}
							}, "复制"));
							return btnArray;
						}
					}
				],
				pageSizeOpts: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
				permission: {
					isAdd: false
				},
				// 图片预览相关 - 简化后的变量
				previewVisible: false,
				previewImagesList: [],
				currentImageIndex: 0,
				advancedQuery: false,
				depotList: [],
				commodityTypePid: 'spzl',
				commoditySelected: [],
				selectedCommodityCount: 0,
				selectedCommodityAmount: 0,
				selectedSKU: false,
				currentCommodity: {
					commodity: {
						id: 0,
						code: '',
						name: '',
						imgFile: [],
						type: '',
						unit: '',
						format: '',
						intoPrice: '',
						wholesalePricePrice: '',
						retailPrice: '',
						enableBatch: false,
						stockPrompt: '',
						isMultiMetering: false,
						extraUnits: [],
						isDifferentPricing: false,
						stock: '',
						commodityInventorys: [],
						commodityPriceTypeGroups: [],
						note: '',
						creator: 0,
						isUse: true
					},
					data: []
				},
				// 防抖相关变量
				debounceTimer: null,
				commodityQuantityChangeDebounced: null,
				debounceAddCommodityCase2: null
			}
		},
		methods: {
			// 防抖函数
			debounce(fn, delay) {
				return (...args) => {
					if (this.debounceTimer) clearTimeout(this.debounceTimer);
					this.debounceTimer = setTimeout(() => {
						fn.apply(this, args);
					}, delay);
				};
			},

			// 初始化防抖函数
			initDebounce() {
				this.commodityQuantityChangeDebounced = this.debounce((val, data) => {
					this._commodityQuantityChange(val, data);
				}, 300);

				this.debounceAddCommodityCase2 = this.debounce(this.addCommodityCase2, 300);
			},

			// 实际的商品数量变更处理
			_commodityQuantityChange(val, data) {
				let step = val;
				if (val < 0) {
					step = 0;
				}
				if (this.type == '1' || this.type == '2') {
					step = data.stock > val ? val : data.stock;
				}

				if (this.isCase1(data)) {
					if (this.commoditySelected.some(item => item.commodity.id == data.id)) {
						this.updateExistingCommodity(step, data);
					} else {
						this.addCommodityCase1(step, data);
					}
				} else {
					this.addCommodityCase2(data);
				}
			},

			// 更新已存在的商品
			updateExistingCommodity(step, data) {
				for (let i = 0; i < this.commoditySelected.length; i++) {
					if (this.commoditySelected[i].commodity.id == data.id) {
						for (let n = 0; n < this.commoditySelected[i].data.length; n++) {
							const priceType = data.commodityPriceTypeGroups[0].groupName + ',' +
								data.commodityPriceTypeGroups[0].commodityPriceTypes[0].priceType;
							if (this.commoditySelected[i].data[n].priceType == priceType) {
								this.commoditySelected[i].data[n].quantity = step;
								break; // 找到后跳出循环
							}
						}
						break; // 找到后跳出循环
					}
				}
			},

			// 切换购物车抽屉显示状态
			toggleShoppingCart() {
				this.shoppingCart = !this.shoppingCart;
			},

			// 处理抽屉关闭事件
			handleDrawerClose() {
				this.shoppingCart = false;
			},

			// 删除已选商品
			removeSelectedItem(index, index2) {
				this.commoditySelected[index].data.splice(index2, 1);
				this.initCommodityList(this.searchItems.pageIndex);
			},
			initCommodityType() {
				let self = this;
				request.get('/api/DataDictionary/GetTreeOfDataDictionary', {
					params: {
						code: self.commodityTypePid
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "初始化界面失败"
						});
						console.log("获取导航树数据失败：" + response.errorMsg)
						return;
					}
					self.commodityTypeData = [];
					self.formatTypeData(self.commodityTypeData, response.data);
				}).catch(function(error) {})
			},
			formatTypeData(dataArray, array) {
				for (var i = 0; i < array.length; i++) {
					dataArray.push({
						id: array[i].id,
						title: array[i].title,
						value: array[i].path,
						expand: array[i].expand,
						selected: array[i].selected,
						note: array[i].note,
						path: array[i].path,
						children: []
					});
					if (array[i].children && array[i].children.length > 0) {
						this.formatTypeData(dataArray[i].children, array[i].children);
					}
				}
			},
			Submit() {
				if (this.commoditySelected.length < 1) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "您还没有选择商品"
					});
					return;
				}
				this.$emit('getResult', this.commoditySelected);
				this.selectCommodityModal = false;
			},
			openSelectCommodityModal() {
				this.commoditySelected = JSON.parse(JSON.stringify(this.selectedCommodity));
				this.initCommodityList(1);
				this.selectCommodityModal = true;
			},
			initCommodityList(index) {
				this.searchItems.pageIndex = index;
				this.searchItems.isUse = this.searchItems.isUse ? this.searchItems.isUse : -1;
				request.post('/api/Commodity/GetCommodityList', this.searchItems).then(response => {
					if (response.state == 0) {
						this.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}
					this.commodityData = response.data.commodity;
					this.commodityCount = response.data.commodityCount;
				}).catch(function(error) {})
			},
			pageChange(index) {
				this.initCommodityList(index);
			},
			pageSizeChange(pageSize) {
				this.searchItems.pageSize = pageSize;
				this.initCommodityList(1);
			},
			addCommodity() {
				this.selectCommodityModal = false;
				this.$router.push({
					path: 'commodityfunc'
				});
			},
			initPermission() {
				let self = this;
				let params = {
					funcCodes: ['Commodity.Add'],
					userId: parseInt(localStorage.getItem("userId"))
				};
				request.post('/api/Function/VerifyPermissions', params).then(function(response) {
					let tipTimeoutCount = localStorage.getItem("_tipTimeoutCount")
					if (tipTimeoutCount != undefined) {
						tipTimeoutCount = parseInt(tipTimeoutCount);
					}
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取权限数据失败：" + response.errorMsg
						});
						return;
					} else if (response.state == 2 && (tipTimeoutCount == undefined || tipTimeoutCount >= 1000)) {
						self.$Modal.warning({
							title: '系统到期提示',
							content: response.errorMsg,
							onOk: () => {
								localStorage.setItem("_tipTimeoutCount", 1);
							}
						});
					}
					if (tipTimeoutCount == undefined || tipTimeoutCount < 1000) {
						localStorage.setItem("_tipTimeoutCount", tipTimeoutCount == undefined ? 1 :
							tipTimeoutCount + 1)
					}
					for (var i = 0; i < response.data.length; i++) {
						switch (response.data[i].funcCode) {
							case 'Commodity.Add':
								self.permission.isAdd = response.data[i].permission
								break;
						}
					}
				}).catch(function(error) {})
			},
			/**
			 * 预览SKU图片 - 简化版本，使用子组件
			 */
			previewSkuImages(images) {
				if (!images || images.length === 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "暂无图片"
					});
					return;
				}

				this.previewImagesList = images;
				this.currentImageIndex = 0;
				this.previewVisible = true;
			},
			/**
			 * 图片切换事件
			 */
			onPreviewImageChange(index, image) {
				this.currentImageIndex = index;
			},
			initDepotData() {
				let self = this;
				request.get('/api/Depot/GetDepotList').then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取仓库数据失败：" + response.errorMsg
						});
						return;
					}
					self.depotList = response.data;
				}).catch(function(error) {})
			},
			getCommodityQuantity(data) {
				let quantity = 0;
				for (let i = 0; i < this.commoditySelected.length; i++) {
					if (this.commoditySelected[i].commodity.id == data.id) {
						for (let n = 0; n < this.commoditySelected[i].data.length; n++) {
							quantity += this.commoditySelected[i].data[n].quantity;
						}
					}
				}
				return formatNum(quantity);
			},
			// 原来的 commodityQuantityChange 方法已被替换为 _commodityQuantityChange

			async addCommodityCase2(item) {
				const current = await this.getCurrentCommodity(item.id);
				if (current) {
					this.initCurrentCommodityData(current);
					this.selectedSKU = true;
				}
			},
			initCurrentCommodityData(param) {
				this.currentCommodity.commodity = param;
				if (this.isMultipleLines) {
					this.currentCommodity.data = this.formatCommodityTypeData(param);
				} else {
					const index = this.commoditySelected.findIndex(m => m.commodity.id == param.id);
					if ((index || index == 0) && index > -1) {
						this.currentCommodity.data = this.formatCommodityTypeData(param);
						this.commoditySelected[index].data.forEach(item => {
							for (let i = 0; i < this.currentCommodity.data.length; i++) {
								if (item.priceType == this.currentCommodity.data[i].priceType) {
									this.currentCommodity.data[i] = JSON.parse(JSON.stringify(item));
								}
							}
						});
						if (this.commoditySelected[index].data.length > 0) {
							this.currentCommodity.commodity.unit = this.commoditySelected[index].data[0].unit;
						}
					} else {
						this.currentCommodity.data = this.formatCommodityTypeData(param);
					}
				}
			},
			selectedUnitChange(index, index2, val) {
				this.commoditySelected[index].data[index2].unit = val;
				if (this.type == '1' || this.type == '2') {
					let maxStock = this.getSelectedCommodityTypeMaxStock(
						index, index2);
					if (this.commoditySelected[index].data[index2].quantity >
						maxStock) {
						this.commoditySelected[index].data[
								index2].quantity =
							maxStock;
					}
				}
				// 解析价格类型
				// const priceTypeItems = this.commoditySelected[index].data[index2].priceType.split(',');
				// let currentPriceType = null;
				// if (priceTypeItems.length === 2) {
				// 	currentPriceType = this.findPriceType(this.commoditySelected[index].commodity, priceTypeItems);
				// }
				// let unitData = this.getUnitData(this.commoditySelected[index].data[index2].unit);
				// if (currentPriceType && unitData) {
				// 	this.commoditySelected[index].data[index2].intoPrice = formatNum(currentPriceType.intoPrice / unitData
				// 		.conversionRate);
				// 	this.commoditySelected[index].data[index2].retailPrice = formatNum(currentPriceType.retailPrice /
				// 		unitData
				// 		.conversionRate);
				// 	this.commoditySelected[index].data[index2].wholesalePricePrice = formatNum(currentPriceType
				// 		.wholesalePricePrice / unitData.conversionRate);
				// }
			},
			skuUnitChange(index, val) {
				this.currentCommodity.data[index].unit = val;
				if (this.type == '1' || this.type == '2') {
					let maxStock = this.getCurrentCommodityTypeMaxStock(
						this.currentCommodity.data[index]);
					if (this.currentCommodity.data[index].quantity >
						maxStock) {
						this.currentCommodity.data[index].quantity =
							maxStock;
					}
				}
			},
			formatCommodityTypeData(param) {
				let data = [];
				param.commodityPriceTypeGroups.forEach(item => {
					item.commodityPriceTypes.forEach(item2 => {
						data.push({
							priceType: item.groupName + ',' + item2.priceType,
							quantity: 0,
							imgFiles: item.imgFiles,
							sellByDate: [],
							unit: param.unit,
							intoPrice: item2.intoPrice,
							retailPrice: item2.retailPrice,
							wholesalePricePrice: item2.wholesalePricePrice
						});
					});
				});
				return data;
			},
			async addCommodityCase1(val, item) {
				const current = await this.getCurrentCommodity(item.id);
				if (current) {
					let step = val;
					if (this.type == '1' || this.type == '2') {
						step = current.stock > step ? step : current.stock;
					}
					this.commoditySelected.push({
						commodity: current,
						data: [{
							priceType: current.commodityPriceTypeGroups[0].groupName + ',' + current
								.commodityPriceTypeGroups[0]
								.commodityPriceTypes[0].priceType,
							quantity: step,
							imgFiles: current.imgFile,
							sellByDate: [],
							unit: current.unit,
							intoPrice: current
								.commodityPriceTypeGroups[0]
								.commodityPriceTypes[0].intoPrice,
							retailPrice: current
								.commodityPriceTypeGroups[
									0]
								.commodityPriceTypes[0].retailPrice,
							wholesalePricePrice: current
								.commodityPriceTypeGroups[0]
								.commodityPriceTypes[0].wholesalePricePrice
						}]
					});
				}
			},
			async getCurrentCommodity(param) {
				let result1 = {};
				try {
					let result = await request.get('api/Commodity/GetCommodity', {
						params: {
							id: param
						}
					});
					if (result.state != 1) {
						this.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取商品信息失败"
						});
						return;
					}
					result1 = result.data;
				} catch (error) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "获取商品信息失败"
					});
				}
				return result1;
			},
			cleanSelected() {
				this.commoditySelected = [];
				this.initCommodityList(1);
			},
			isDisableStock(stock) {
				if (stock <= 0 && (this.type == "1" || this.type == '2')) {
					return false
				}
				return true
			},
			isCase1(data) {
				return data.isUse == true && data.isMultiMetering == false && data.enableBatch == false && data
					.commodityPriceTypeGroups
					.length == 1 && data
					.commodityPriceTypeGroups[0].commodityPriceTypes.length == 1;
			},
			getCurrentCommodityTypeMaxStock(data) {
				if (!this.currentCommodity.commodity.commodityInventorys) return 0;
				let stock = 0;
				this.currentCommodity.commodity.commodityInventorys.forEach(item => {
					if (item.commodityPriceType == data.priceType) {
						stock += item.stock;
					}
				})
				if (this.isMultipleLines) {
					// 减去已选数量
					for (let i = 0; i < this.commoditySelected.length; i++) {
						if (this.currentCommodity.commodity.id == this.commoditySelected[i].commodity.id) {
							this.commoditySelected[i].data.forEach(item => {
								if (item.priceType == data.priceType) {
									this.commoditySelected[i].commodity.extraUnits.forEach(item2 => {
										if (item.unit == item2.unit) {
											stock -= item.quantity / item2.conversionRate;
										}
									});
								}
							});
						}
					}
				}

				let unitData = this.getUnitData(data.unit);
				if (unitData) {
					stock = unitData.conversionRate * stock;
				}
				if (stock && Number.isFinite(stock)) {
					return formatNum(stock);
				} else {
					return 0;
				}
			},
			getUnitData(unitName) {
				if (this.currentCommodity.commodity.extraUnits) {
					let unit = this.currentCommodity.commodity.extraUnits.find(m => m.unit == unitName);
					if (unit) {
						return unit;
					}
				}
				return null;
			},
			getCommodityTypePrice(param1, param2) {
				const currentUnit = param1.commodity.extraUnits.find(m => m.unit == param2.unit);
				// 解析价格类型
				const priceTypeItems = param2.priceType.split(',');
				let currentPriceType = null;

				if (priceTypeItems.length === 2) {
					currentPriceType = this.findPriceType(param1.commodity, priceTypeItems);
				}
				if (currentUnit && currentPriceType) {
					let price = 0;
					if (this.type == '0' || this.type == '1') {
						price = currentPriceType.intoPrice;
					}
					if (this.type == '2' || this.type == '3') {
						price = currentPriceType.retailPrice;
					}
					return formatNum(price / currentUnit.conversionRate);
				}
				return 0;
			},
			// 提取价格类型查找逻辑
			findPriceType(commodity, priceTypeItems) {
				const [groupName, priceTypeName] = priceTypeItems;

				const targetGroup = commodity.commodityPriceTypeGroups.find(
					group => group.groupName === groupName
				);

				if (!targetGroup) return null;

				return targetGroup.commodityPriceTypes.find(
					priceType => priceType.priceType === priceTypeName
				) || null;
			},
			saveSelectedSKU() {
				const data = JSON.parse(JSON.stringify(this.currentCommodity));
				if (this.isMultipleLines) {
					this.commoditySelected.push(data);
				} else {
					const index = this.commoditySelected.findIndex(m => m.commodity.id == this.currentCommodity
						.commodity.id);
					if ((index || index == 0) && index > -1) {
						this.$set(this.commoditySelected, index, data)
					} else {
						this.commoditySelected.push(data);
					}
				}
				this.selectedSKU = false;
			},
			getCommodityTypeStockByParam(index1, index2) {
				if (!this.commoditySelected[index1].commodity.commodityInventorys) return 0;
				let stock = 0;
				let commodityInventorys = this.commoditySelected[index1].commodity.commodityInventorys;
				for (let i = 0; i < commodityInventorys.length; i++) {
					if (commodityInventorys[i].commodityPriceType == this.commoditySelected[index1].data[index2]
						.priceType) {
						stock += commodityInventorys[i].stock;
					}
				}
				let unitData = this.commoditySelected[index1].commodity.extraUnits.find(m => m.unit == this
					.commoditySelected[index1].data[index2].unit);
				
				if (unitData) {
					stock = unitData.conversionRate * stock;
				}
			
				if (stock && Number.isFinite(stock)) {
					return formatNum(stock);
				} else {
					return 0;
				}
			},
			getSelectedCommodityTypeMaxStock(index1, index2) {
				if (!this.commoditySelected[index1].commodity.commodityInventorys) return 0;
				let stock = 0;
				let commodityInventorys = this.commoditySelected[index1].commodity.commodityInventorys;
				for (let i = 0; i < commodityInventorys.length; i++) {
					if (commodityInventorys[i].commodityPriceType == this.commoditySelected[index1].data[index2]
						.priceType) {
						stock += commodityInventorys[i].stock;
					}
				}

				// 减去已选数量
				for (let i = 0; i < this.commoditySelected.length; i++) {
					if (i != index1) {
						if (this.commoditySelected[index1].commodity.id == this.commoditySelected[i].commodity.id) {
							for (let n = 0; n < this.commoditySelected[i].data.length; n++) {
								if (this.commoditySelected[i].data[n].priceType == this.commoditySelected[index1].data[
										index2].priceType) {
									for (let j = 0; j < this.commoditySelected[i].commodity.extraUnits.length; j++) {
										if (this.commoditySelected[i].data[n].unit == this.commoditySelected[i].commodity
											.extraUnits[j].unit) {
											stock -= this.commoditySelected[i].data[n].quantity / this.commoditySelected[i]
												.commodity.extraUnits[j].conversionRate;
										}
									}
								}
							}
						}
					}
				}

				let unitData = this.commoditySelected[index1].commodity.extraUnits.find(m => m.unit == this
					.commoditySelected[index1].data[index2].unit);

				if (unitData) {
					stock = unitData.conversionRate * stock;
				}
				if (stock && Number.isFinite(stock)) {
					return formatNum(stock);
				} else {
					return 0;
				}
			},
			copyItem(index, index2) {
				if (this.commoditySelected[index].commodity.commodityPriceTypeGroups.length == 1 &&
					this.commoditySelected[index].commodity.commodityPriceTypeGroups[0]
					.commodityPriceTypes.length == 1) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "该商品只有一种规格，不可复制行"
					});
					return;
				}
				let detailItem = JSON.parse(JSON.stringify(this.commoditySelected[index].data[index2]));
				if (this.type == '1' || this.type == '2') {
					let maxStock = this.getSelectedCommodityTypeMaxStock(index, index2);
					maxStock -= detailItem.quantity;
					if (maxStock <= 0) {
						this.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "已超出该商品的最大库存"
						});
						return;
					}
					if (maxStock < detailItem.quantity) {
						detailItem.quantity = formatNum(maxStock);
					}
				}

				let obj = {
					commodity: null,
					data: []
				};

				obj.commodity = this.commoditySelected[index].commodity;
				obj.data.push(detailItem);
				this.commoditySelected.push(obj);
			},
		},
		watch: {
			'commoditySelected': {
				deep: true,
				handler(arr) {
					this.selectedCommodityCount = 0;
					this.selectedCommodityAmount = 0;
					for (let i = this.commoditySelected.length - 1; i >= 0; i--) {
						for (let n = this.commoditySelected[i].data.length - 1; n >= 0; n--) {
							if (this.commoditySelected[i].data[n].quantity <= 0) {
								this.commoditySelected[i].data.splice(n, 1);
							} else {
								this.selectedCommodityCount += this.commoditySelected[i].data[n].quantity;
								this.selectedCommodityAmount += this.getCommodityTypePrice(this.commoditySelected[i], this
									.commoditySelected[i].data[n]) * this.commoditySelected[i].data[n].quantity;
							}
						}
						if (this.commoditySelected[i].data.length <= 0) {
							this.commoditySelected.splice(i, 1);
						}
					}
					this.selectedCommodityCount = formatNum(this.selectedCommodityCount);
					this.selectedCommodityAmount = formatNum(this.selectedCommodityAmount);
				}
			},
			selectedCommodityCount(val) {
				console.log(val);
			}
		},
		created: function() {
			this.initPermission();
			this.initDepotData();
			this.initCommodityType();
			// 初始化防抖函数
			this.initDebounce();
		},
		beforeDestroy() {
			// 清理防抖定时器
			if (this.debounceTimer) {
				clearTimeout(this.debounceTimer);
				this.debounceTimer = null;
			}
		}
	}
</script>

<style scoped>
	.modal-content {
		min-height: 500px;
	}

	#page-box {
		margin-top: 15px;
		text-align: center;
	}

	.selected-goods {
		float: left;
		height: 52px;
		line-height: 52px;
		text-align: center;
		width: auto;
		padding: 0px 10px;
		color: #fff;
		background-color: rgb(255, 106, 127);
		font-size: 15px;
		cursor: pointer;
		font-weight: bold;
		border-radius: 0px 0px 0px 6px;
	}

	/deep/ .ivu-modal-footer {
		padding: 0px !important;
		background-color: rgba(255, 255, 255, 0) !important;
	}

	.selected-sku {
		float: left;
		height: 32px;
		line-height: 32px;
		text-align: center;
		width: auto;
		padding: 0px 10px;
		color: rgb(255, 106, 127);
		font-size: 15px;
		cursor: pointer;
		font-weight: bold;
		border-radius: 0px 0px 0px 6px;
	}

	.footer-tool {
		padding: 10px;
	}

	/deep/ .ivu-badge-count {
		top: -3px;
	}

	/deep/ .ivu-modal-content {
		background-color: white;
	}

	/deep/ .ivu-modal-body {
		padding: 0px;
	}

	#box-search {
		margin-bottom: 15px;
		overflow: hidden;
	}

	.search_input {
		width: 200px;
		margin-right: 15px;
	}

	.box-search-left {
		float: left;
	}

	.box-search-right {
		float: right;
	}

	.modal-header {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		overflow: hidden;
		color: rgb(255, 106, 127);
	}

	/* 抽屉内容区域样式 */
	.drawer-content {
		padding: 10px;
	}

	.drawer-content-item {}

	.drawer-content-item+.drawer-content-item {
		border-top: 1px solid #e8e8e8;
		padding-top: 10px;
		margin-top: 10px;
	}

	.drawer-content-item /deep/ div {
		border: none !important;
	}

	.content-input {
		border: none;
		outline: none;
		height: 15px;
		padding-left: 0px;
		width: 100%;
		flex: 1;
		text-align: right;
		margin: 0px 15px;
	}
</style>